import { Collapse as CollapseAntd } from 'antd';
import styled from 'styled-components';

const Collapse = styled(CollapseAntd)`
  .ant-collapse-item {
    background-color: #f1f1f1;
  }
`;

const { Panel: CollapsePanel } = Collapse;

export { Collapse, CollapsePanel };
